import * as React from 'react';
import QRCodeService from '../../../../../../services/QRCodeService';
import { LocalizationService } from '../../../../../../services/LocalizationService';
import * as styles from './QRCode.css';
import { PlayHelper } from '../../../../../playAdmin/PlayHelper';

export interface IProps {
  link: string;
  linkText?: string;
  sizeUnit: number;
  style?: React.CSSProperties;
  language?: string; 
  backgroundColor?: string;
  textColor?: string;
}

export interface IState {
  qrCode?: string;
}

export class QRCode extends React.Component<IProps, IState> {

  private localizationService: LocalizationService;

  constructor(props: IProps) {
    super(props);
    this.state = { };
    this.localizationService = new LocalizationService(PlayHelper.getLocalizerLanguageFromPlayerLanguage(this.props.language));
  }

  componentDidMount(): void {
    if (this.props.link) {
      try {
        QRCodeService.generateQRCode(this.props.link, this.props.backgroundColor, this.props.textColor).then((qrCode: string) => {
          if (qrCode) {
            this.setState({ qrCode });
          }
        });
      } catch (error) {
        console.log(`%c${error}`, 'background: red; color: #ffffff')
      }
    }
  }

  public render(): JSX.Element {
    return (
      <div
        className={styles.IA_QRCode}
        style={{
          position: "absolute",
          width: this.props.sizeUnit * 8,
          borderRadius: this.props.sizeUnit * 0.5,
          ...this.props.style
        }}
      >
        <div
          style={{
            marginTop: 0,
            fontWeight: "bold",
            fontSize: this.props.sizeUnit * 0.8,
            marginBottom: this.props.sizeUnit,
            textAlign: "center",
            paddingTop: this.props.linkText !== "" ? this.props.sizeUnit : 2,
            paddingLeft: this.props.sizeUnit,
            paddingRight: this.props.sizeUnit,
            color: this.props.textColor ? this.props.textColor : "#333333",
            overflowWrap: "anywhere",
            hyphens: "auto"
          }}
        >
          {this.props.linkText ?? this.localizationService.strings.Player_More?.toUpperCase()}
        </div>
        <img
          src={this.state.qrCode}
          className={styles.IA_QRCodeImage}
          style={{
            width: this.props.sizeUnit * 7,
            height: this.props.sizeUnit * 7,
            paddingLeft: this.props.sizeUnit,
            paddingRight: this.props.sizeUnit,
            paddingBottom: this.props.sizeUnit,
            backgroundColor: this.props.backgroundColor ? this.props.backgroundColor : "#ffffff",
          }}
        />
      </div >
    );
  }
}